var merchant_list = JSON.parse(localStorage.getItem('merchant_list'));

var mItems = [];

if (merchant_list && merchant_list[0].merchant_qr_code_system_type == 'doorlock' )
{
	
	
	
	mItems = [  
		{title: 'Main',	url: '/'}, 
		{title: 'Merchants', url: '/merchant'},
		{title: 'Users', url: '/user', submenu: [ {title: 'Create User', url: '/user/create'}]},
		{title: 'Devices', url: '/device', submenu: [ {title: 'Create Device', url: '/device/create'}]},
		{title: 'Reports', url: '/monthlyreport', submenu: [{title: 'Monthly', url: '/monthlyreport'}, {title: 'Daily', url: '/dailyreport'} /*, {title: 'Monthly User', url: '/monthlyreport'} */]}, 
		{title: 'Payment', url: '/payment' /* , submenu: [{title: 'My Payment History', url: '/payment/history'}] */}, 
	]; 
}
else if (merchant_list && merchant_list[0].merchant_qr_code_system_type == 'ticket')
{
	mItems = [  
		{title: 'Main',	url: '/'}, 
		{title: 'Merchants', url: '/merchant'},
		/* {title: 'Devices', url: '/device', submenu: [ {title: 'Create Device', url: '/device/create'}]}, */
		{title: 'Events', url: '/event'},
		{title: 'Pass', url: '/normalticket'},  
		{title: 'City Pass',  url: '/citypassticket',},
		{title: 'Reports', url: '/monthlyreport', submenu: [{title: 'Monthly', url: '/monthlyreport'}, {title: 'Daily', url: '/dailyreport'} /*, {title: 'Monthly User', url: '/monthlyreport'} */]}, 
		{title: 'Payment', url: '/payment' /*, submenu: [{title: 'My Payment History', url: '/payment/history'}] */}, 
	]; 
}
else if (merchant_list && merchant_list[0].merchant_qr_code_system_type == 'coupon')
{
	mItems = [  
		{title: 'Main',	url: '/'}, 
		{title: 'Merchants', url: '/merchant'},
		/* {title: 'Coupon Users', url: '/couponuser', submenu: [ {title: 'Create Coupon User', url: '/couponuser/create'}]}, */
		{title: 'Users', url: '/user', submenu: [ {title: 'Create User', url: '/user/create'}]},
		// {title: 'Coupon Events', url: '/couponevent', submenu: [{title: 'Create Coupon Events',url: '/couponevent/create'}]},
		{title: 'Reports', url: '/monthlyreport', submenu: [{title: 'Daily', url: '/dailyreport'}/* , {title: 'Monthly User', url: '/monthlyreport'} */]}, 
		{title: 'Payment', url: '/payment' /*, submenu: [{title: 'My Payment History', url: '/payment/history'}] */}, 
	]; 
}
else 
{
	mItems = [  
		{title: 'Main',	url: '/'}, 
		{title: 'Merchants', url: '/merchant'},
		{title: 'Users', url: '/user', submenu: [ {title: 'Create User', url: '/user/create'}]},
		{title: 'Devices', url: '/device', submenu: [ {title: 'Create Device', url: '/device/create'}]},
		{title: 'Reports', url: '/monthlyreport', submenu: [{title: 'Daily', url: '/dailyreport'}/* , {title: 'Monthly User', url: '/monthlyreport'} */]}, 
		{title: 'Payment', url: '/payment' /*, submenu: [{title: 'My Payment History', url: '/payment/history'}] */}, 
	]; 
}
	

export const menuItemsData = mItems; 

/*
export const menuItemsData = [
  {
	title: 'Main',
	url: '/',
  }, 
  
  {
    title: 'Merchants',
    url: '/merchant',
  },
    	
 
  
  {
    title: 'Users',
    url: '/user',
    submenu: [
      {
        title: 'Create User',
        url: '/user/create',
      },
    ],
  },
    
  
  {
    title: 'Devices',
    url: '/device',
    submenu: [
      {
        title: 'Create Device',
        url: '/device/create',
      },
    ],
  },
  
  {
    title: 'Normal Pass',
    url: '/ticket',
  },  

  {
    title: 'City Pass',
    url: '/ticket',
  },

 {
    title: 'Coupon',
    url: '/device',
    submenu: [
      {
        title: 'Create Device',
        url: '/device/create',
      },
    ],
  },
  
  {
    title: 'Reports',
    url: '/monthlyreport',
	 submenu: [
      {
        title: 'Daily',
        url: '/monthlyreport',
      },
      {
        title: 'Monthly User',
        url: '/monthlyreport',
      },
	  
    ],
  }, 
    
	
  
  {
    title: 'Payment',
    url: '/payment',
	 submenu: [
      {
        title: 'My Payment History',
        url: '/payment/history',
      },
    ],	
  }, 
  
//		

  {
    title: 'User Meta Profile',
    url: '/usermetaprofilemgt',
  },


  {
    title: 'VM',
    url: '/vm',
    submenu: [
      {
        title: 'Web Design',
        url: 'web-design',
      },
      {
        title: 'Web Development',
        url: 'web-dev',
      },
      {
        title: 'SEO',
        url: 'seo',
      },
    ],
  },
  
    {
    title: 'Services',
    url: '/services',
    submenu: [
      {
        title: 'Web Design',
        url: 'web-design',
      },
      {
        title: 'Web Development',
        url: 'web-dev',
      },
      {
        title: 'SEO',
        url: 'seo',
      },
    ],
  },
  ////////////////////////////////////////////////////////
  // ...
];
*/